import _api from "./api";
import _endpoints from "./endpoints";

export default {
    async isAvailableDelivery(obj) {
        const { data } = await _api.get(_endpoints.schedule_box_delivery_is_available, {
            params: {
                date: obj.date,
                time: obj.time,
            }
        });

        return data || null;
    },
    async getListForDelivery(date) {
        const { data } = await _api.get(_endpoints.schedule_box_delivery.replace(':day', date));

        return data || null;
    },
}

